import { render } from "./v-addProduct.vue?vue&type=template&id=d59996a0"
import script from "./v-addProduct.vue?vue&type=script&lang=js"
export * from "./v-addProduct.vue?vue&type=script&lang=js"

import "./v-addProduct.vue?vue&type=style&index=0&id=d59996a0&lang=css"
script.render = render

export default script